import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";
import { TPurpose, TRegisterMessengerChannel, TRegisterMessengerHost } from "./type";
import { TMember } from "types/user.types";
import { TSlackChannel } from "apis/messangers";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

export const updateWalkInVisitActive = async (deviceId: string, isWalkInVisitEnabled: boolean): Promise<boolean> => {
  try {
    const res = await instance.patch("/visitors/setting/device/walk-in-visit", {
      id: deviceId,
      isWalkInVisitEnabled: isWalkInVisitEnabled,
    });
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId, isWalkInVisitEnabled: isWalkInVisitEnabled } });
    return false;
  }
};

export const getWalkInVisitPurpose = async (deviceId: string): Promise<TPurpose[] | undefined> => {
  try {
    const res = await instance.post("/visitors/setting/device/walk-in-visit/purpose", {
      id: deviceId,
    });

    return res.data;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId } });
  }
};

export const updateVisitPurpose = async (deviceId: string, visitPurposes: TPurpose[]): Promise<boolean> => {
  try {
    const res = await instance.patch("/visitors/setting/device/walk-in-visit/purpose", {
      id: deviceId,
      visitPurposes: visitPurposes,
    });
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: deviceId, visitPurposes: visitPurposes } });
    return false;
  }
};

export const getVisitPurposeHost = async (
  purposeId: string
): Promise<{ receivers: TRegisterMessengerHost[]; channels: TRegisterMessengerChannel[] } | undefined> => {
  try {
    const res = await instance.post("/visitors/setting/device/walk-in-visit/purpose/host", {
      id: purposeId,
    });
    return res.data;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: purposeId } });
  }
};

export const deleteWalkInVisitHost = async (hostId: string): Promise<boolean> => {
  try {
    const res = await instance.delete("/visitors/setting/device/walk-in-visit/purpose/host", {
      data: {
        id: hostId,
      },
    });
    return res.data.result;
  } catch (error) {
    Sentry.captureException(error, { extra: { id: hostId } });
    return false;
  }
};

//INFO: (new) device/방문목적별 담당자(DM) 등록
export const registerWalkInVisitPurposeHost = async (
  purposeId: string,
  members: TMember[]
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/visitors/setting/device/walk-in-visit/purpose/host/receiver", {
      visitorsSettingPurposeId: purposeId,
      memberList: members,
    });
    return { success: res.data.result };
  } catch (error) {
    Sentry.captureException(error, { extra: { visitorsSettingPurposeId: purposeId, memberList: members } });
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

export const registerWalkInVisitPurposeChannel = async (purposeId: string, channel: TSlackChannel) => {
  try {
    const res = await instance.patch("/visitors/setting/device/walk-in-visit/purpose/host/channel", {
      id: purposeId,
      messengerType: "SLACK",
      channelInfo: {
        channelId: channel.slackChannelId,
        channelName: channel.slackChannelName,
      },
    });
    return res.data.result;
  } catch (error) {
    return false;
  }
};
